import { Injectable } from '@angular/core';
import { HttpRequestComponent } from 'src/app/shared/http-request/http-request.component';
import { ActiveInactiveFor, CustomLabelInitialization, CustomPrintLabelForBill, FontStyleDetailWrapper, KeyValues10, KeyValues3, KeyValues5, LocalService, StatusWithId, Wrappers5 } from './local.service';
import { service_controllers_methods } from './service_controllers_methods';
import { Observable } from 'rxjs';
import * as req from 'src/app/entities/request';
import * as res from 'src/app/entities/response';

@Injectable({
  providedIn: 'root'
})
export class PrinterService {
  private printerConfiguration = service_controllers_methods.printer.controller;
  private methodsConfiguration = service_controllers_methods.printer.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public isPrinterTabAvailable(req: req.BusinessDetail, isShowSpinner: boolean = true): Observable<res.PrinterTabAvailability[]> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.IsPrinterTabAvailable, body, isShowSpinner);
  }

  public isPrinterNameAvailable(req: req.BusinessDetail): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.IsPrinterNameAvailable, body);
  }

  public getPrinterNames(req: req.BusinessDetail): Observable<res.PrinterName[]> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetPrinterNames, body);
  }

  public savePrinterNames(req: req.PrinterName): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.SavePrinterNames, body);
  }

  public isPrinterDeviceAvailable(req: req.BusinessDetail): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.IsPrinterDeviceAvailable, body);
  }

  public getPrinterDevices(req: req.BusinessDetail): Observable<res.PrinterDevice[]> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetPrinterDevices, body);
  }

  public savePrinterDevice(req: req.PrinterDevice): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.SavePrinterDevice, body);
  }

  public isPrinterTemplateAvailable(req: req.BusinessDetail): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.IsPrinterTemplateAvailable, body);
  }

  public getPrinterTemplate(req: req.BusinessDetail, key: string): Observable<res.PrinterTemplate> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req,
      id: key
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetPrinterTemplate, body);
  }

  public getPrinterTemplates(req: req.BusinessDetail): Observable<res.PrinterTemplate[]> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetPrinterTemplates, body);
  }

  public savePrinterTemplate(req: req.PrinterTemplate): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.SavePrinterTemplate, body);
  }

  public isPrinterTemplateMapAvailable(req: req.BusinessDetail): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.IsPrinterTemplateMapAvailable, body);
  }

  public getPrinterTemplateMaps(req: req.BusinessDetail): Observable<res.PrinterTemplateMap[]> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetPrinterTemplateMaps, body);
  }

  public savePrinterTemplateMap(req: req.PrinterTemplateMap): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.SavePrinterTemplateMap, body);
  }

  public isPrinterDeviceMapAvailable(req: req.BusinessDetail): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.IsPrinterTemplateMapAvailable, body);
  }

  public getPrinterDeviceMaps(req: req.BusinessDetail): Observable<res.PrinterDeviceMap[]> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetPrinterDeviceMaps, body);
  }

  public savePrinterDeviceMap(req: req.PrinterDeviceMap): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.SavePrinterDeviceMap, body);
  }

  public getPrinterDevice(req: req.BusinessDetail, key: string): Observable<res.PrinterDevice> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req,
      id: key
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetPrinterDevice, body);
  }

  public getPrinterTemplateMap(req: req.BusinessDetail, key: string): Observable<res.PrinterTemplateMap> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req,
      id: key
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetPrinterTemplateMap, body);
  }

  public getPrinterDeviceMap(req: req.BusinessDetail, key: string): Observable<res.PrinterDeviceMap> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req,
      id: key
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetPrinterDeviceMap, body);
  }

  public activeInactiveStatus(req: req.BusinessDetail, key: string, activeInactiveFor: ActiveInactiveFor): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req,
      id: key,
      forId: activeInactiveFor
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.ActiveInactiveStatus, body);
  }

  public savePrinterSetup(req: req.PrinterSetup): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.SavePrinterSetup, body);
  }

  public getPrinterSetupByBusinessId(req: req.BusinessDetail): Observable<res.PrinterSetup> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetPrinterSetupByBusinessId, body);
  }

  public getPrinterSetupsByDeviceId(req: req.DevicePrinterSetup, impersonateBusinessIds?: string[], isShowSpinner = false): Observable<res.DevicePrinterSetupWrapper> {
    const body = {
      sel: this.localService.getSelected(),
      dt: req,
      ids: impersonateBusinessIds
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetPrinterSetupsByDeviceId, body, isShowSpinner);
  }


  public getPrinterSetupByBusinessIds(countryCode: string, businessIds: string[], isShowSpinner = false): Observable<res.PrinterSetup[]> {
    const body = {
      sel: this.localService.getSelected(),
      dt: { CountryCode: countryCode } as req.BusinessDetail,
      ids: businessIds
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetPrinterSetupByBusinessIds, body, isShowSpinner);
  }

  public getCustomLabelPrints(countryCode: string, businessId: string, languageId: string, isIncludeInActive?: boolean): Observable<CustomPrintLabelForBill[]> {
    const body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: languageId, v3: isIncludeInActive ? '1' : '0' } as KeyValues5,
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetCustomLabelPrints, body);
  }

  public saveCustomLabelPrint(businessId: string, languageId: string, data: CustomPrintLabelForBill): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: languageId } as KeyValues3,
      data: data
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.SaveCustomLabelPrint, body);
  }

  public getCustomLabelPrintById(id?: string): Observable<CustomPrintLabelForBill> {
    const body = {
      sel: this.localService.getSelected(),
      dt: { v1: id } as KeyValues3
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetCustomLabelPrintById, body);
  }

  public getCustomLabelPrintsMinInitialization(countryCode: string, businessId: string, languageId: string, isActive?: boolean, isOnlyPinned?: boolean): Observable<CustomLabelInitialization> {
    const body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: languageId, v3: isActive ? '1' : '0', v4: isOnlyPinned ? '1' : '0' } as KeyValues5,
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetCustomLabelPrintsMinInitialization, body);
  }

  public getCustomLabelPrintsMin(countryCode: string, businessId: string, languageId: string, isActive?: boolean, isOnlyPinned?: boolean): Observable<Wrappers5[]> {
    const body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: languageId, v3: isActive ? '1' : '0', v4: isOnlyPinned ? '1' : '0' } as KeyValues5,
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetCustomLabelPrintsMin, body);
  }

  public saveFontSetting(data: FontStyleDetailWrapper): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      data: data
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.SaveFontSetting, body);
  }

  public getPrintReceiptIconsByBusinessId(businessId: string): Observable<KeyValues10[]> {
    const body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues3,
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetPrintReceiptIconsByBusinessId, body);
  }

  public getPrintFontSettingByBusinessId(businessId: string, isGetOptions?: boolean): Observable<FontStyleDetailWrapper> {
    const body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: isGetOptions ? '1' : '0' } as KeyValues3,
    };
    return this.httpService.request_general_post(this.printerConfiguration + this.methodsConfiguration.GetPrintFontSettingByBusinessId, body);
  }
}
